import { render, staticRenderFns } from "./BacklinksDetails.vue?vue&type=template&id=08b6ea01&scoped=true"
import script from "./BacklinksDetails.vue?vue&type=script&lang=js"
export * from "./BacklinksDetails.vue?vue&type=script&lang=js"
import style0 from "./BacklinksDetails.vue?vue&type=style&index=0&id=08b6ea01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6ea01",
  null
  
)

export default component.exports